module.exports = __webpack_public_path__ + "static/media/T-shirt_dark.1dbd5b5d.svg";